"use strict";

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var api_method_1 = require("../api_method");

var api_resource_1 = require("../api_resource");

var constants_1 = require("../constants");

var SignaturesResource =
/*#__PURE__*/
function (_api_resource_1$APIRe) {
  _inherits(SignaturesResource, _api_resource_1$APIRe);

  function SignaturesResource(apiClient) {
    var _this;

    _classCallCheck(this, SignaturesResource);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignaturesResource).call(this, apiClient));
    _this.path = '/signatures';
    _this.broadcast = api_method_1.apiMethod({
      method: constants_1.POST
    }).bind(_assertThisInitialized(_this));
    return _this;
  }

  return SignaturesResource;
}(api_resource_1.APIResource);

exports.SignaturesResource = SignaturesResource;